// Selector to get all items in the cart
export const selectCartItems = (state) => state.cart.items;

// Selector to get the total amount in the cart
export const selectCartTotal = (state) => state.cart.totalAmount;

// Selector to get the total quantity of items in the cart
export const selectTotalQuantity = (state) =>
  state.cart.items.reduce((total, item) => total + item.quantity, 0);
